import React from "react";

import classnames from "classnames";

import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("InsuranceTypeIcon");

const IconWrapper = ({ children, color, ...rest }) => (
  <Div
    {...rest}
    className={classnames(bem("Wrapper"), {
      [bem("Wrapper", "blue")]: color === "blue",
      [bem("Wrapper", "gray")]: color === "gray",
    })}
  >
    {children}
  </Div>
);

export const LifeIcon = ({ color = "blue" }) => (
  <IconWrapper color={color} aria-label="Life insurance icon of a hand holding a heart.">
    <Icon icon="hand-holding-heart" size="2x" flavor="solid" />
  </IconWrapper>
);
export const ShortTermDisabilityIcon = ({ color = "blue" }) => (
  <IconWrapper color={color} aria-label="Short term disability insurance icon of person with broken arm.">
    <Icon icon="user-injured" size="2x" flavor="solid" />
  </IconWrapper>
);
export const LongTermDisabilityIcon = ({ color = "blue" }) => (
  <IconWrapper color={color} aria-label="Long term disability insurance icon of a person moving on a wheelchair.">
    {/* TODO(font-awesome-6): Use correct icon. To use the 'wheelchair-move' icon we need to upgrade to FontAwesome v6 */}
    <Icon icon="wheelchair" size="2x" flavor="solid" />
  </IconWrapper>
);
